export var firebaseConfig = {
    apiKey: "AIzaSyAxJKF6ySY5ytrSOpQD3NRFLRVUqMtz9po",
    authDomain: "shtiltestsettask.firebaseapp.com",
    projectId: "shtiltestsettask",
    storageBucket: "shtiltestsettask.appspot.com",
    messagingSenderId: "1049408849894",
    appId: "1:1049408849894:web:7fce5bac4a7aa39d05f827",
    measurementId: "G-1BHPGSRLMM"
};